import React, { Component } from 'react';
import { Container } from './styles';
import { Link } from 'react-router-dom';
import receipt from '../../assets/emojis/financeiro/receipt.png';
import calendario from '../../assets/emojis/financeiro/calendario@3x.png';
import { FiChevronDown } from 'react-icons/fi';
import api from '../../services/api';
import moment from 'moment';
import 'moment/locale/pt-br';
import Collapse from "@kunukn/react-collapse";
import { DivAccordion } from '../tempo-entrega/styles';
import { useState } from 'react';


moment.locale('pt-br')
console.log(moment('2022-09-10').format('YYYY-MM-DD') > moment().format('YYYY-MM-DD'))


export default class Financeiro extends Component {

    constructor(props) {
        super(props);
        this.state = {
            carregou: true,
            token: localStorage.getItem('@jwt'),
            rest: JSON.parse(localStorage.getItem('@rest')),
            valorTotal: '',
            periodo: [],
            ano: [],
            vencimento: '',
            valor: '',
            numeroFatura: '',
            situacao: '',
            visualizarFatura: '',
            cidade: '',
            dadosFatura: [],
            ultimaFatura: [],
            isOpen: false
        };
    }

    componentDidMount() {
        const token = localStorage.getItem('@jwt');
        const isSuser = localStorage.getItem('@internal');
        const rest = JSON.parse(localStorage.getItem('@rest'));
        this.setState({ token: token, rest: rest });
        this.salvar()
    }

    // async salvar() {

    //     try {
    //         api.post('api/todasFaturas', {
    //             rest_id: this.state.rest.id
    //         }, {
    //             headers: {
    //                 Authorization: `Bearer ${this.state.token}`

    //             }
    //         }).then(res => {
    //             this.setState({
    //                 dadosFatura: res.data.result.reverse(),
    //                 ultimaFatura: res.data.result[0],
    //             });

    //         }).catch(async e => {
    //             console.log(e.data, 'erro da api')
    //         });

    //     } catch (error) {
    //         console.log(error.data);
    //     }
    // }

    async salvar() {
        try {
            const response = await api.post('api/todasFaturas', {
                rest_id: this.state.rest.id
            }, {
                headers: {
                    Authorization: `Bearer ${this.state.token}`
                }
            });
    
            const dadosFatura = response.data.result.sort((a, b) => {
                // Ordena com base na propriedade 'created' (do mais recente para o mais antigo)
                return new Date(b.created) - new Date(a.created);
            });
    
            this.setState({
                dadosFatura: dadosFatura,
                ultimaFatura: dadosFatura[0], // Última fatura após a ordenação
            });
    
        } catch (error) {
            console.log(error.data);
        }
    }
    
    
    Mobile = () => () => {
      
        const dados = this.state.dadosFatura
        return <> 
        {dados.map((item, index) => {
      const [test, setTest] = React.useState(false);
      const isLastItem = index === dados.length - 1;

            return <div className="div__mobile__over" key={item.id}>
                <div className="div__mobile">
                    <DivAccordion
                        open={test}
                        onClick={() => {
                             if(!test) setTest(true)
                            else setTest(false)
                        }
                        }>

                        <div>
                            <span className="head">Periodo</span>
                            <div className="body-div">
                                <span className="body">{moment(item.periodo).add(1, 'day').format('MMMM')}</span>
                            </div>
                        </div>

                        <div>
                            <span className="head">Ano</span>
                            <div className="body-div">
                                <span className="body">{item.ano}</span>
                            </div>
                        </div>

                        <div className="icon">
                            <FiChevronDown color={'#000000'} size={24} className="chevron" />
                        </div>
                    </DivAccordion>


                    <Collapse transition={'height 280ms cubic-bezier(0.4, 0, 0.2, 1)'} isOpen={test}>

                        <span className="head">Num. Fatura</span>
                        <div className="body-div">
                            <span className="body">{item.id}</span>
                        </div>

                        <span className="head">Vencimento</span>
                        <div className="body-div">
                            <span className="body">{
                                `${item.vencimento}/${moment(item.created).format('MM')}/${moment(item.created).format('YYYY')}`
                            }
                            </span>
                        </div>

                        <span className="head">Valor Total</span>
                        <div className="body-div">
                            <span className="body">{Number(item.valor_total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                            </span>
                        </div>

                        <span className="head">Situação</span>
                        <div className="body-div">
                            <div className='body'
                                style={{
                                    fontWeight: 'bold',
                                    'color': item.situacao == 'pago'
                                        ?
                                        'green'
                                        :
                                        item.situacao == 'pendente'
                                            &&
                                            moment().format('YYYY-MM-DD')
                                            > `${moment(item.created).format('YYYY')}-${moment(item.created).format('MM')}-${item.vencimento}`
                                            ?
                                            '#9c1a1f'
                                            :
                                            '#CDA07C'
                                }}
                            >{
                                    item.situacao == 'pago'
                                        ?
                                        'Paga'
                                        :
                                        item.situacao == 'pendente'
                                            &&
                                            moment().format('YYYY-MM-DD')
                                            > `${moment(item.created).format('YYYY')}-${moment(item.created).format('MM')}-${item.vencimento}`
                                            ?
                                            'Em atraso'
                                            :
                                            'Em aberto'
                                }</div>
                        </div>

                        <div class="botao">
                            <button className="salvar" onClick={() => { }}>
                                <a className='salvar1' href={`https://financeiro.appedidos.com.br/fatura/${this.state.ultimaFatura.id}`} target='_blank'>
                                    {this.state.ultimaFatura.situacao == 'pago'
                                        ?
                                        'Visualizar fatura'
                                        :
                                        'Fazer pagamento'
                                    }
                                </a>
                            </button>
                        </div>
                    </Collapse>

                    {isLastItem ? null : <hr />}
                </div>
                
            </div>
        }
        )}</>
    }
    render() {
        const Mobile = this.Mobile()
        console.log('fatura', this.state.dadosFatura);
        console.log(this.state.rest.id)

        return (

            <Container>
                
                {this.state.dadosFatura.length > 0 ?
                // this.state.carregou ?
                    <div className="div-pai">
                        <div className="div-rota">

                            <Link
                                style={{ textDecoration: 'none' }}
                                to={'/'}>
                                <span
                                    className="rotas" >
                                    Início
                                </span>
                            </Link>

                            <span className="rotas"> {'>'} </span>

                            <Link
                                style={{ textDecoration: 'none' }}
                                to={'/financeiro'}>
                                <span>
                                    Financeiro
                                </span>
                            </Link>

                        </div>

                        <div className="titulo">
                            <img alt="" className="emoji" src={receipt} />
                            <h1>Financeiro</h1>
                            <h5>Visualize suas faturas atuais e também seu histórico.</h5>
                        </div>

                        <hr className="linha" />

                        <h3>Fatura atual</h3>

                        <div className='row-fatura'>
                            <div className='coluna'>
                                <span className='subs'>Num. Fatura</span>
                                <span className='situacao'>{this.state.ultimaFatura.id}</span>
                            </div>

                            <div className='coluna'>
                                <span className='subs'>Situação</span>
                                <span className='situacao' style={{
                                    fontWeight: 'bold',
                                    'color': this.state.ultimaFatura.situacao == 'pago'
                                        ?
                                        'green'
                                        :
                                        this.state.ultimaFatura.situacao == 'pendente'
                                            &&
                                            moment().format('YYYY-MM-DD')
                                            > `${moment(this.state.ultimaFatura.created).format('YYYY')}-${moment(this.state.ultimaFatura.created).format('MM')}-${this.state.ultimaFatura.vencimento}`
                                            ?
                                            '#9c1a1f'
                                            :
                                            '#000'
                                }} >
                                    {
                                        this.state.ultimaFatura.situacao == 'pago'
                                            ?
                                            'Pagamento efetuado'
                                            :
                                            this.state.ultimaFatura.situacao == 'pendente'
                                                &&
                                                moment().format('YYYY-MM-DD')
                                                > `${moment(this.state.ultimaFatura.created).format('YYYY')}-${moment(this.state.ultimaFatura.created).format('MM')}-${this.state.ultimaFatura.vencimento}`
                                                ?
                                                'Pagamento em atraso'
                                                :
                                                'Aguardando pagamento'
                                    }</span>
                            </div>
                        </div>


                        <div>
                            <img alt="" className="calendario" src={calendario} />
                        </div>

                        <div className='row'>
                            <div className='coluna'>
                                <span className='informacao'>Período</span>
                                <span className='dadosFatura'>{moment(this.state.ultimaFatura.periodo).add(1, 'day').format('MMMM')}</span>
                            </div>

                            <div className='coluna'>
                                <span className='informacao'>Ano</span>
                                <span className='dadosFatura'>{this.state.ultimaFatura.ano}</span>
                            </div>

                            <div className='coluna'>
                                <span className='informacao'>Vencimento</span>
                                <span className='dadosFatura'>{
                                    `${this.state.ultimaFatura.vencimento}/${moment(this.state.ultimaFatura.created).format('MM')}/${moment(this.state.ultimaFatura.created).format('YYYY')}`
                                }</span>
                            </div>

                            <div className='coluna'>
                                <span className='informacao'>Valor</span>
                                <span className='dadosFatura'>{Number(this.state.ultimaFatura.valor_total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                            </div>
                        </div>

                        {/*--------------------- MOBILE ---------------------------- */}

                        <div className='row-mobile'>
                            <div className='coluna-mobile'>
                                <div className='coluna'>
                                    <span className='informacao'>Período</span>
                                    <span className='dadosFatura'>{moment(this.state.ultimaFatura.periodo).add(1, 'day').format('MMMM')}</span>
                                </div>

                                <div className='coluna'>
                                    <span className='informacao'>Vencimento</span>
                                    <span className='dadosFatura'>{
                                        `${this.state.ultimaFatura.vencimento}/${moment(this.state.ultimaFatura.created).format('MM')}/${moment(this.state.ultimaFatura.created).format('YYYY')}`
                                    }</span>
                                </div>
                            </div>

                            <div className='row-mobile'>
                                <div className='coluna-mobile'>
                                    <div className='coluna'>
                                        <span className='informacao'>Ano</span>
                                        <span className='dadosFatura'>{this.state.ultimaFatura.ano}</span>
                                    </div>

                                    <div className='coluna'>
                                        <span className='informacao'>Valor</span>
                                        <span className='dadosFatura'>{Number(this.state.ultimaFatura.valor_total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="botao">
                            <button className="salvar" onClick={() => { }}>
                                <a className='salvar1' href={`https://financeiro.appedidos.com.br/fatura/${this.state.ultimaFatura.id}`} target='_blank'>
                                    {this.state.ultimaFatura.situacao == 'pago'
                                        ?
                                        'Visualizar fatura'
                                        :
                                        'Fazer pagamento'
                                    }
                                </a>
                            </button>
                        </div>

                        <hr className="linha" />

                        <h3>Histórico de faturas</h3>

                        <div>
                            
                        <table>
                            <thead>
                                <tr>
                                <th className='info'>Período</th>
                                <th className='info'>Ano</th>
                                <th className='info'>Num. Fatura</th>
                                <th className='info'>Vencimento</th>
                                <th className='info'>Valor Total</th>
                                <th className='info'>Situação</th>
                                <th className='info'>Visualizar Fatura</th>
                                </tr>
                            </thead>
                            <tbody>
                                {this.state.dadosFatura.map((item, index) => (
                                <tr className={index === this.state.dadosFatura.length - 1 ? 'last-row' : ''}>
                                    <td className='dados'>{moment(item.periodo).add(1, 'day').format('MMMM')}</td>
                                    <td className='dados'>{item.ano}</td>
                                    <td className='dados'>{item.id}</td>
                                    <td className='dados'>{`${item.vencimento}/${moment(item.created).format('MM')}/${moment(item.created).format('YYYY')}`}</td>
                                    <td className='dados'>{Number(item.valor_total).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}</td>
                                    <td
                                    className='dados'
                                    style={{
                                        fontWeight: 'bold',
                                        color:
                                        item.situacao === 'pago'
                                            ? 'green'
                                            : item.situacao === 'pendente' && moment().format('YYYY-MM-DD') > `${moment(item.created).format('YYYY')}-${moment(item.created).format('MM')}-${item.vencimento}`
                                            ? '#9c1a1f'
                                            : '#CDA07C',
                                    }}
                                    >
                                    {item.situacao === 'pago' ? 'Paga' : item.situacao === 'pendente' && moment().format('YYYY-MM-DD') > `${moment(item.created).format('YYYY')}-${moment(item.created).format('MM')}-${item.vencimento}` ? 'Em atraso' : 'Em aberto'}
                                    </td>
                                    <td className='dados'>
                                    <a href={`https://financeiro.appedidos.com.br/fatura/${item.id}`} id='meulink' target='_blank'>
                                        Clique aqui para visualizar
                                    </a>
                                    </td>
                                </tr>
                                ))}
                            </tbody>
                            </table>


                            {/*--------------------- MOBILE ---------------------------- */}

                        <Mobile/>
                        </div>
                    </div>

                    :

                    <div className="div-pai">
                        <div className="div-rota">

                            <Link
                                style={{ textDecoration: 'none' }}
                                to={'/'}>
                                <span
                                    className="rotas" >
                                    Início
                                </span>
                            </Link>

                            <span className="rotas"> {'>'} </span>

                            <Link
                                style={{ textDecoration: 'none' }}
                                to={'/financeiro'}>
                                <span> 
                                    Financeiro
                                </span>
                            </Link>

                        </div>

                    <div className='fundo'>
                        <div className="titulo">

                            <img alt="" className="emoji" src={receipt} />

                            <h1>Financeiro</h1>

                            <span className='textosemfatura'>Visualize suas faturas atuais e também seu histórico.</span>

                        </div>

                        <hr className="linha_null" />

                            <div className='titulo'>
                                <span className='texto_null'>Fatura atual</span>
                                <span className='textosemfatura'>Ainda não há fatura disponível</span>


                                <span className='texto_null'>Histórico de faturas</span>
                                <span className='textosemfatura'>Ainda não há histórico de faturas disponível</span>
                            </div>
                        </div>
                    </div>  
                }
            </Container>
        )
    }
}

